import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = guest, object = authed
  const [outlet, setOutlet] = useState(null);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("kos_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data.restaurant_id) {
        try { const o = await api.get("/outlet"); setOutlet(o.data); } catch { /* noop */ }
      }
    } catch {
      localStorage.removeItem("kos_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const setAuth = (payload) => {
    localStorage.setItem("kos_token", payload.token);
    setUser(payload.user);
    setOutlet(null);
    if (payload.user?.restaurant_id) api.get("/outlet").then((o) => setOutlet(o.data)).catch(() => {});
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    localStorage.removeItem("kos_token");
    setUser(false);
    setOutlet(null);
  };

  const refreshOutlet = async () => {
    try { const o = await api.get("/outlet"); setOutlet(o.data); return o.data; } catch { return null; }
  };

  const refreshUser = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, outlet, setAuth, logout, refreshOutlet, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
